'use client';

import { c as _c } from "react/compiler-runtime";
import type { DefaultHttpResponseListHomeNoticeResponse } from '__generated__/api/unauth';
import { useQuery } from '@tanstack/react-query';
import { AuthQueryOptions, UnauthQueryOptions } from '@/api';
import { LoadingPageTemplate } from '@/components/client';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
import { useAuthStore } from '@/stores/AuthStore';
import { NoticeListItem } from './_components/NoticeListItem';
interface NoticeListProps {
  initialData?: DefaultHttpResponseListHomeNoticeResponse;
}
export const NoticeList = t0 => {
  const $ = _c(15);
  const {
    initialData
  } = t0;
  const isLogin = useAuthStore(_temp);
  const {
    entry
  } = useWebviewTypeEntry();
  let t1;
  if ($[0] !== entry || $[1] !== isLogin) {
    t1 = isLogin ? AuthQueryOptions["get:/wello/v2/auth/home-notice"]() : UnauthQueryOptions["get:/wello/v2/allows/home-notice"]({
      query: {
        entry
      }
    });
    $[0] = entry;
    $[1] = isLogin;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isLogin !== undefined;
  let t3;
  if ($[3] !== initialData || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      ...t1,
      placeholderData: initialData,
      select: _temp2,
      enabled: t2
    };
    $[3] = initialData;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: notices,
    isLoading
  } = useQuery(t3);
  const isLoadingDimShow = isLoading || isLogin === undefined;
  let t4;
  if ($[7] !== isLoading || $[8] !== notices) {
    t4 = !isLoading ? notices?.length === 0 ? <p className="p-20 text-center font-400 text-Gray-600 typo-body3">공지사항이 없습니다.</p> : notices?.map(_temp3) : null;
    $[7] = isLoading;
    $[8] = notices;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isLoadingDimShow) {
    t5 = isLoadingDimShow ? <LoadingPageTemplate unmountedPlaceholder={true} /> : null;
    $[10] = isLoadingDimShow;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <ul className="flex flex-col">{t4}{t5}</ul>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(t0) {
  const {
    context
  } = t0;
  return context?.contents ?? [];
}
function _temp3(t0) {
  const {
    categoryType: category_type,
    dday,
    title,
    homeNoticeId: home_notice_id
  } = t0;
  return <NoticeListItem key={home_notice_id} title={title} dday={dday} categoryType={category_type} noticeId={home_notice_id} />;
}